const API_BASE = process.env.REACT_APP_API_URL || 'https://api.grandindigoembroidery.com';

const headers = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
});

// ─── Token helpers ────────────────────────────────────────────────────────────

export const saveToken = (token) => localStorage.setItem('gie_token', token);
export const getToken  = ()      => localStorage.getItem('gie_token');
export const removeToken = ()    => localStorage.removeItem('gie_token');

export const saveUser = (user)  => localStorage.setItem('gie_user', JSON.stringify(user));
export const getUser  = ()      => {
  try { return JSON.parse(localStorage.getItem('gie_user')); } catch { return null; }
};
export const removeUser = ()    => localStorage.removeItem('gie_user');

export const isLoggedIn = () => !!getToken();

export const logout = () => {
  removeToken();
  removeUser();
};

// ─── Auth API calls ───────────────────────────────────────────────────────────

/**
 * Login
 * @param {string} email
 * @param {string} password
 * @returns {{ token, user }}
 */
export const login = async (email, password) => {
  const res = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Login failed.');
  saveToken(data.token);
  saveUser(data.user);
  return data;
};

/**
 * Register
 * @param {Object} payload
 * @param {string} payload.first_name
 * @param {string} payload.last_name
 * @param {string} payload.email
 * @param {string} payload.phone
 * @param {string} payload.password
 * @param {string} payload.password_confirmation
 * @returns {{ token, user }}
 */
export const register = async (payload) => {
  const res = await fetch(`${API_BASE}/auth/register`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    // Laravel validation errors come back as { errors: { field: [msg] } }
    if (data.errors) {
      const first = Object.values(data.errors)[0];
      throw new Error(Array.isArray(first) ? first[0] : first);
    }
    throw new Error(data.message || 'Registration failed.');
  }
  saveToken(data.token);
  saveUser(data.user);
  return data;
};

/**
 * Send forgot password email
 * @param {string} email
 */
export const forgotPassword = async (email) => {
  const res = await fetch(`${API_BASE}/auth/forgot-password`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Could not send reset email.');
  return data;
};